import type { Allergen } from '@lemontaigu/pms-core';
import type { LegalAllergen } from '@lemontaigu/shared';

// The French label of each allergen code a person can be ticked with (group
// edit step 5). The labels ARE the menu's list — LEGAL_ALLERGENS in the shared
// kernel — typed against it, so a second spelling is a compile error and the
// kitchen reads the same word on a guest as on a dish (brief §6). The codes are
// what the database stores (`pms_allergen_codes()`); allergens.test.ts checks
// the two lists are the same fourteen.
export const ALLERGEN_LABELS_FR: Record<Allergen, LegalAllergen> = {
  gluten: 'Gluten',
  crustaceans: 'Crustacés',
  eggs: 'Œufs',
  fish: 'Poissons',
  peanuts: 'Arachides',
  soybeans: 'Soja',
  milk: 'Lait',
  nuts: 'Fruits à coque',
  celery: 'Céleri',
  mustard: 'Moutarde',
  sesame: 'Sésame',
  sulphites: 'Sulfites',
  lupin: 'Lupin',
  molluscs: 'Mollusques',
};
